import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Catalog } from './pricing';

export function errorMessage(error: any) {
	const message = error?.response?.data?.message;

	return Array.isArray(message)
		? message.join(' · ')
		: typeof message === 'string'
		? message
		: 'לא הצלחנו לשמור או לטעון את הנתונים';
}

export default function useCatalog() {
	const [catalog, setCatalog] = useState<Catalog>({
		categories: [],
		services: [],
	});
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');

	const reload = useCallback(async () => {
		setLoading(true);
		setError('');

		try {
			setCatalog((await axios.get<Catalog>('/services-catalog')).data);
		} catch (e) {
			setError(errorMessage(e));
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		reload();
	}, [reload]);

	return { catalog, loading, error, reload };
}
